import React from "react";
import { Chip } from "@material-ui/core";
import styled from "styled-components";

import { color, fontFamily, fontSize } from "style/constants";
import { ReactComponent as RobotIcon } from "assets/robot.svg";
import { ReactComponent as ClinicianLight } from "assets/clinician-light.svg";
import { ReactComponent as ClinicianDark } from "assets/clinician-dark.svg";

export const StyledName = styled.p`
  margin: 0;
`;

export const StyledAssessmentName = styled.h1`
  font-family: ${fontFamily.secondary};
  font-size: 30px;
  margin: 0;
`;

export const StyledCycleTitle = styled.h1`
  font-family: ${fontFamily.secondary};
  font-size: 30px;
  font-weight: normal;
  margin: 0;
`;

export const StyledNotesButton = styled.p`
  color: ${color.DARKBLUE};
  font-weight: 300;
  margin: 0;
`;

export const StyledCompletionText = styled.p`
  color: ${color.DARKERGRAY};
  font-size: ${fontSize.small};
  margin: 0;
`;

export const StyledResponseTitle = styled.h3`
  margin: 0;
`;

export const StyledResponseBody = styled.p`
  color: ${color.DARKERGRAY};
  margin-bottom: 0;
`;

interface PassageTextProps {
  expand: boolean;
}

export const StyledPassageText = styled.p<PassageTextProps>`
  color: ${color.DARKERGRAY};
  font-style: normal;
  font-weight: normal;
  font-size: ${fontSize.normal};
  line-height: 25px;
  margin-bottom: 0;
  display: -webkit-box;
  -webkit-line-clamp: ${props => (props.expand ? "none" : "3")};
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const StyledTotalScore = styled.h2`
  color: ${color.DARKBLUE};
  font-size: 22px;
  font-weight: 600;
  margin: 0;
`;

export const StyledScoreText = styled.h2`
  font-size: 22px;
  font-weight: 400;
  margin: 0;
`;

export const StyledChip = styled(Chip)`
  && {
    font-size: 16px;
    padding: 1.25rem 0.1rem 1.25rem 0.25rem;
    border-radius: 8px;
    margin: 0.25rem;
    overflow: visible;
    display: inline-flex;
  }
`;

interface StyledClinicianIconProps {
  isLight?: boolean;
}

export const StyledClinicianIcon = styled(({ isLight, ...props }: StyledClinicianIconProps) =>
  isLight ? <ClinicianLight {...props} /> : <ClinicianDark {...props} />
)`
  width: 24px;
  height: 24px;
  vertical-align: bottom;
  margin-left: 6px;
`;

interface StyledLabelProps {
  disabled: boolean;
}

export const StyledLabel = styled.label<StyledLabelProps>`
  position: relative;
  display: inline-flex;
  align-items: baseline;
  opacity: ${props => (props.disabled ? "0.8" : "1")};
`;

export const SmallRobotIcon = styled(RobotIcon)`
  width: 14px;
  height: auto;
  position: relative;
  vertical-align: baseline;
  margin-right: 0.35rem;
  margin-left: 0.35rem;
`;

export const ThemeKeyText = styled.p`
  color: ${color.DARKERGRAY};
  font-style: normal;
  font-weight: normal;
  font-size: ${fontSize.small};
  line-height: 150%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin: 0;
`;
